import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  Output,
  EventEmitter,
  HostListener
} from '@angular/core';
import { Configuration, AttributesEntity, ElementAction } from '../../models/configuration.model';
import { ListOutputDTO } from '../../models/ListDTO.model';
import { DxDataGridComponent } from 'devextreme-angular';
import { DataStoreService } from '../../core/services/data-store/data-store.service';
import { Map } from '../../models/objects.model';
import * as AspNetData from 'devextreme-aspnet-data';
import { LookAndFillStoreService } from '../../services/look-and-fill-store/look-and-fill-store.service';
import { SearchFilterSortService } from 'ng-searchfiltersort';
import { ActiveViewStoreService } from '../../services/active-view-store/active-view-store.service';
import { FunctionStoreService } from '../../services/function-store/function-store.service';

// TODO MK-REF
@Component({
  selector: 'baf-data-view-grid',
  templateUrl: './data-view-grid.component.html',
  styleUrls: ['./data-view-grid.component.css']
})
export class DataViewGridComponent implements OnInit, AfterViewInit {
  @ViewChild(DxDataGridComponent)
  dataGrid: DxDataGridComponent;

  @Output()
  dataLoaded = new EventEmitter<string>();

  dataLoadingText = 'Ładowanie danych';
  noDataText = 'Brak danych';
  pageInfoText = 'Strona {0} z {1}';
  response: ListOutputDTO;
  loadedData = false;
  dataSource: any;
  config: Configuration;
  def: any;
  showFilterRow = true;
  gridVisible = true;
  rowQuantity = 15;
  listPages: number[] = [];
  element: Element = null;
  url: string;
  button: Node = null;
  functionStore: FunctionStoreService;

  columns: {
    dataField: string;
    caption: string;
    filterOperations: string[];
    selectedFilterOperation: string;
    width: string;
    cellTemplate?: string;
    class?: string;
    alignment?: string;
    dataType?: string;
    format?: string;
  }[] = [];

  clicker(e): void {
    this.storeService.currentId = e.key;
    this.storeService.setCurrentRowData(e.data);
  }

  con(e): void {
    this.storeService.currentId = e.row.key;
    let m: Map[];
    m = <Map[]>e.row.data;
    this.storeService.setCurrentRowData(m);
  }

  onContentReady(e): void {
    let elements = <HTMLElement[]><any>document.querySelectorAll('.dx-data-row');
    for (var i = 0; i < elements.length; i++) {
        elements[i].style["white-space"] = "nowrap";
    };
    const dx_page_sizes = document.querySelector('.dx-page-sizes');
    const dx_datagrid_pager = document.querySelector('.dx-datagrid-pager');
    this.element = document.querySelector('[aria-label="Column Akcje, Value undefined"]');
    if (this.element != null) {
      this.element.innerHTML =
        '<span class="dx-icon-preferences icon global-action-icon" sytle="color:darkblue" ></span>';
    }
    if (dx_page_sizes != null && !dx_datagrid_pager.classList.contains('dx-hidden')) {
      if (this.button == null) {
        this.button = document.querySelector('dx-button#refresh').cloneNode(true);
        this.button.addEventListener('click', () => {
          this.refreshDataGrid();
        });
        document.querySelector('baf-data-view-grid>dx-button#refresh').remove();
      }
      document.querySelector('.dx-page-sizes').appendChild(this.button);
    } else if (this.button != null) {
      document.querySelector('baf-data-view-grid').appendChild(this.button);
    }
  }

  cellHoverChanged(e): void {}

  calculateCellValue(data): string {
    return '';
  }

  chooseType(val): string {
    switch (val) {
      case 0:
        return 'string';
      case 1:
        return 'number';
      case 2:
        return 'number';
      case 3:
        return 'boolean';
      case 4:
        return 'date';
      case 5:
        return 'object';
    }
    return 'string';
  }

  chooseFormat(dataType): string {
    // There is a bug in displaying date-time column (there is a chance, that the version of DevExpress we use, is faulty).
    // Even that the format is 'MM.dd.yyyy hh:mm:ss', the grid shows is as 'dd.MM.yyyy hh:mm:ss'
    if(dataType == 4) return 'MM.dd.yyyy HH:mm:ss';
    return null;
  }

  constructor(
    private storeService: DataStoreService, 
    private activeViewStore: ActiveViewStoreService,
    private lookAndFeel: LookAndFillStoreService,
    private sfsService: SearchFilterSortService,
    functionStore: FunctionStoreService
  ) {
    this.url = this.storeService.apiUrl + 'Data/';
    this.functionStore = functionStore;
    storeService.getCurrentView().subscribe(node => {
      this.dataGrid.instance.pageIndex(0);
      this.config = storeService.getConfiguration();
      const elementAction = node.action as ElementAction;

      if (!elementAction || !elementAction.elementId) {
        return;
      }

      this.storeService.currentElementId = elementAction.elementId;
      this.storeService.currentElementViewId = elementAction.elementViewId;
      this.activeViewStore.setCurrentViewId(elementAction.elementId);

      let basicAttributes: AttributesEntity[] = [];
      let attributes: AttributesEntity[] = [];
      const properElement = this.config.businessModel.elements.find(
        element => element.id.toUpperCase() === elementAction.elementId.toUpperCase()
      );
      if (properElement) {
        basicAttributes = properElement.attributes;
        if (properElement.genericElementViews) {
          const properView = properElement.genericElementViews.find(
            element => element.id.toUpperCase() === elementAction.elementViewId.toUpperCase()
          );
          if (properView) {
            attributes = properView.attributes;
          }
        }
      }
      this.columns = [];
      attributes = this.sfsService.orderBy(attributes, 'order');

      for (const attribute of attributes) {
        if (attribute.displayMode > 0) {
          this.columns.push({
            dataField: attribute.businessModelElementAttrId,
            caption: basicAttributes.find(
              e => e.id.toUpperCase() === attribute.businessModelElementAttrId.toUpperCase()
            ).displayName.name,
            filterOperations: [''],
            selectedFilterOperation: '',
            width: '',
            dataType: this.chooseType(
              basicAttributes.find(
                e => e.id.toUpperCase() === attribute.businessModelElementAttrId.toUpperCase()
              ).businessType
            ),
            format: this.chooseFormat(
              basicAttributes.find(
                e => e.id.toUpperCase() === attribute.businessModelElementAttrId.toUpperCase()
              ).businessType
            )
          });
        }
      }

      this.columns.push({
        dataField: '',
        caption: 'Akcje',
        filterOperations: [''],
        selectedFilterOperation: '',
        width: '100',
        cellTemplate: '<span class="dx-icon-menu icon context-menu-icon"></span>',
        class: 'menu',
        alignment: 'Center'
      });

      this.restoreOrder();

      this.dataSource = AspNetData.createStore({
        key: node.id + '_ZAWIADOMIENIA-ID',
        loadUrl: this.url,
        loadParams: {
          elementId: elementAction.elementId.toString(),
          elementViewId: elementAction.elementViewId.toString()
        },
        onBeforeSend: (e, ajax) => {
          ajax.xhrFields = {
            withCredentials: true
          };          
        }
      });

      // TODO Wyliczać na podstawie rzeczywistej wielkości komponentu.
      const calcValue = Math.floor((window.innerHeight - 350) / 3 / this.lookAndFeel.fontSize);
      this.listPages = [];
      if (5 <= calcValue) {
        this.listPages.push(5);
      }
      if (10 <= calcValue) {
        this.listPages.push(10);
      }
      if (15 <= calcValue) {
        this.listPages.push(15);
      }
      if (this.listPages.indexOf(calcValue) === -1) {
        this.listPages.push(calcValue);
        this.listPages.sort((a, b) => a - b);
      }

      this.dataLoaded.emit('loaded');
    });
  }

  ngOnInit() {}

  onRowPrepared(e): void {
    const tableStatusName = this.columns.find(x => x.caption === 'Status');
    const tableTypName = this.columns.find(x => x.caption === 'Typ');
    if (
      e.rowType === 'data' &&
      ((['PrzyjetePrzezAdresata', 'Odrzucone'].indexOf(e.data[tableStatusName.dataField]) > -1 &&
        ['Egib2Zsin', 'Egib2Nkw', 'Egib2Op', 'Rciwn2Zsin', 'Not2Us', 'Not2Egib'].indexOf(e.data[tableTypName.dataField]) > -1) 
        ||
        (e.data[tableStatusName.dataField] === 'PrzekazaneDoAdresata' &&
          [
            'Egib2Cbdoz',
            'Nkw2Egib',
            'Zsin2Egib',
            'Cbdoz2Egib',
            'Crfop2Egib',
            'Emuia2Egib',
            'Emuia2Teryt',
            'Not2Us',
            'Not2Egib'
          ].indexOf(e.data[tableTypName.dataField]) > -1)
        ||
        (e.data[tableStatusName.dataField] === 'PrzekazaneDoAdresata' &&
          ['Wypis2Egib'].indexOf(e.data[tableTypName.dataField]) > -1))
      ) {
      e.rowElement.style.fontWeight = 'bold';
    }
  }

  onOptionChanged(e) {
    if (e.name === 'columns' && e.fullName && e.value) {
      const option: string = e.fullName;
      const result = option.match(/^columns\[([0-9]+)\]\.sortOrder$/);
      if (result && result.length === 2) {
        const orderInfo = {
          columnIndex: Number.parseInt(result[1]),
          direction: e.value
        };
        this.activeViewStore.storeSelectedOrder(orderInfo);
      }
    }
  }

  private restoreOrder() {
    this.activeViewStore.restoreSelectedOrder().then(orderInfo => {
      if (orderInfo) {
        this.dataGrid.instance.clearSorting();
        this.dataGrid.instance.columnOption(orderInfo.columnIndex, {
          sortOrder: orderInfo.direction
        });
      }
    });
  }

  ngAfterViewInit() {}

  @HostListener('window:resize', ['$event.target'])
  onWindowResize(target) {
    this.dataGrid.instance.refresh();
  }
  refreshDataGrid() {
    this.storeService.refreshNode();
    this.dataGrid.instance.refresh();
    const dx_tree = document.getElementById('simple-treeview');
    this.functionStore.refreshFunctions();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/data-view-grid/data-view-grid.component.ts